import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useModal } from "hooks/useModal";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useToast } from "hooks/useToast";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useQuery } from "hooks/useQuery";
import { useAddProductsToCartAndCheckoutMutation } from "store/apis/billing";
import { BillingInvoice } from "types/Models/billing";
import { TaskDeadlineOverviewItem } from "types/Models/task";
import { BackendError } from "types/utils/error";

export const useRegistrationCheckout = () => {
  const { isForeignCA, isAdmin } = useRoleBasedView();
  const { alertToast } = useToast();
  const history = useHistory();
  const { uuid: groupId } = useCurrentGroupContext();
  const query = useQuery();
  const entityId = query.get("entity");

  const [invoice, setInvoice] = useState<BillingInvoice | null>(null);
  const checkoutModal = useModal();
  const [checkout, { isLoading: checkingOut }] =
    useAddProductsToCartAndCheckoutMutation();

  const handleFileNow = async (task: TaskDeadlineOverviewItem) => {
    if (!groupId || !entityId) return;
    try {
      const result = await checkout({
        groupId,
        entityId,
        productData: [
          {
            entity_id: entityId,
            product_id: task.base_task_template.uuid,
            product_content_type_id: task.product_content_type_id!,
            season: String(task.season),
            quantity: 1,
            payment_amount: Number(task.payment_amount) || 0,
            alarm_id: task.alarm_uuid || undefined,
          },
        ],
        from_alarms: true,
      }).unwrap();
      setInvoice(result.invoice);
      checkoutModal.open();
    } catch (e) {
      alertToast({ message: (e as BackendError)?.data?.error?.message });
    }
  };

  const closeCheckoutModal = () => {
    setInvoice(null);
    checkoutModal.close();
  };

  const onPaymentSuccess = () => {
    closeCheckoutModal();
    const filingsUrl = isAdmin
      ? `/admin/crm/${groupId}/new-filings`
      : `/tax/filings`;
    history.push(filingsUrl);
  };

  return {
    invoice,
    setInvoice,
    checkoutModal,
    checkingOut,
    isForeignCA,
    entityId,
    handleFileNow,
    closeCheckoutModal,
    onPaymentSuccess,
  };
};
